import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts  from 'react-highcharts'
import { Grid } from "@material-ui/core";
import { number } from "../../../utils";

import styles from "./styles.scss";

const config = {
    chart:{
        animation: false,
        margin: 50,
        style: {
            fontFamily: "Helvetica",
        }
    },
    credits: {
        enabled: false,
    },
    title: {
      text: "",
    },
    tooltip: {
        enabled: false
    },
    legend: {
        enabled: false,
    },
    xAxis: {
        type: 'category',
        tickWidth: 0,
        lineColor: null,
        title: {
            style: {
                color: '#D5D5D5'
            },
        },
        labels: {
            style: {
                fontSize: "14px",
                color: '#999'
            }
        }
    },
    yAxis: {
        title: {
            text: null,
        },
        labels: {
            style: {
                fontSize: "14px",
                color: '#999',
            }
        },
        visible: false,
    },
    plotOptions: {
        line: {
            dataGrouping: {
                enabled: false,
                groupAll: true,
            },
            turboThreshold: 0,
        },
    },
    series: [
        {
            type: 'column',
            data: [],
            color: '#0f2748',
            name: '',
            pointPadding: 0.05,
            groupPadding: 0.1,
            dataLabels: {
                enabled: true,
                crop: false,
                overflow: 'none',
                formatter: function(){
                    if(this.point.color === "#2D9BB1") {
                        return ('<span style="font-weight:600;font-size:15px;color:' + this.point.color + '">' + number.parseNumber(this.y, 0) + '</span>');
                    } else {
                        return ('<span style="font-weight:400;font-size:15px;color:' + this.point.color + '">' + number.parseNumber(this.y, 0) + '</span>');
                    }
                },
            }
        },
    ],
  };

@CSSModules(styles, { allowMultiple: true })
class MonthlyUsageComparisonChart extends Component {
    constructor(props){
        super(props);
        this.chart = React.createRef();
    }
    
	render() {
		return (
            <div>
                <div styleName="header-container">
                    <div styleName="header-text">{this.props.monthName} kWh</div>
                </div>
                <div styleName="filter-options">
                    {this.props.filters.map((filter, index) => 
                        <div styleName="filter-option" key={index} isselected={(filter === this.props.currentFilter).toString()} onClick={() => this.props.selectFilter(filter)}>
                            {filter}
                        </div>
                    )}
                </div>
                <div styleName="chart-container">
                <ReactHighcharts
                config={config}
                ref={this.chart}
                isPureConfig={true}
            />
                </div>
            </div>
		);
    }

    componentDidMount(){
        let chart = this.chart.current.getChart();
        if(chart) {
            this.props.startLiveData(chart);
            setTimeout(() => {
               if(chart) {
                  chart.reflow();
                  chart.redraw();
               }
            }, 100);
        }
    }

    componentWillUnmount(){
        this.props.stopLiveData();
    }
}

const bindAction = dispatch => {
    return {
        selectFilter: (filter) => dispatch(actions.selectFilter(filter)),
        startLiveData: (chart) => dispatch(actions.startLiveData(chart)),
        stopLiveData: () => dispatch(actions.stopLiveData()),
    };
};

const mapStateToProps = (state, ownProps) => ({
    filters: state.monthlyusagecomparisonchart.filters,
    currentFilter: state.monthlyusagecomparisonchart.selectedFilter,
    monthName: state.monthlyusagecomparisonchart.monthName,
});

export default connect(mapStateToProps, bindAction)(MonthlyUsageComparisonChart);



// WEBPACK FOOTER //
// ./src/components/LiveComponents/MonthlyUsageComparisonChart/MonthlyUsageComparisonChart.js